module.exports = __webpack_public_path__ + "img/chevron_left_gray600.0c406fb7.svg";